import api from '../../services/serviceBase'

export default {
      AddUpdateMessagingTemplate(templateDetails){
        return api.execute('post', `/Messaging/AddUpdateMessagingTemplate`, templateDetails)
      },
      GetMessagingTemplateList(practice){
        return api.execute('get', `/Messaging/MessagingTemplateList?practiceCode=${practice}`)
      },
      DeleteMessagingTemplate(id){
          return api.execute('post', `/Messaging/DeleteMessagingTemplateById?id=${id}`)
      }      
  }